import styled from "styled-components";

export const SAddProjectModalSectionsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
`;
